import { noReminder } from 'owa-locstrings/lib/strings/noreminder.locstring.json';
import { repeatNever } from 'owa-locstrings/lib/strings/repeatnever.locstring.json';
import { everyoneAvailable } from 'owa-locstrings/lib/strings/everyoneavailable.locstring.json';
import { addLocationText } from 'owa-locstrings/lib/strings/addlocationtext.locstring.json';
import { bodyPlaceholderText } from 'owa-locstrings/lib/strings/bodyplaceholdertext.locstring.json';
import { remindMe } from 'owa-locstrings/lib/strings/remindme.locstring.json';
import { repeat } from 'owa-locstrings/lib/strings/repeat.locstring.json';
import {
    freCalendarInviteCalendarName,
    freCalendarInviteInviteDate,
    freCalendarInviteCurrentDate,
} from './EnterpriseCalendarInviteScene.locstring.json';
import { findRecipientResult_SuggestedContactsHeader } from 'owa-locstrings/lib/strings/findrecipientresult_suggestedcontactsheader.locstring.json';
import loc from 'owa-localize';

import { observer } from 'mobx-react-lite';
import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function PhotoHubScene(props: {}) {
    return (
        <div className={classNames('prop', 'new-event-module')}>
            <div className={classNames('prop', 'title-of-event')}>
                <b className={classNames('cursor-terminated')}>
                    <span className="initial">Lunch at Fourth</span>
                    <i>&nbsp;</i>
                    <i>C</i>
                    <i>o</i>
                    <i>f</i>
                    <i>f</i>
                    <i>e</i>
                    <i>e</i>
                </b>
            </div>

            <mark className={classNames('prop', 'string-coverup', 'context')}>
                {loc(freCalendarInviteCalendarName)}
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'date')}>
                {loc(freCalendarInviteInviteDate)}
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'repeat')}>
                {loc(repeat)} {loc(repeatNever)}
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'room')}>
                {loc(addLocationText)}
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'remind')}>
                {loc(remindMe)} {loc(noReminder)}
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'desc')}>
                {loc(bodyPlaceholderText)}
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'event', 'alpha')}>
                Weekly stand-up
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'event', 'beta')}>
                Send final art
            </mark>
            <mark className={classNames('prop', 'string-coverup', 'today')}>
                {loc(freCalendarInviteCurrentDate)}
            </mark>

            <div className={classNames('prop', 'text-revealer')}>
                <div className={classNames('prop', 'i-beam')} />
            </div>

            <div className={classNames('prop', 'invite-people')}>
                <div className={classNames('prop', 'title')}>
                    {loc(findRecipientResult_SuggestedContactsHeader)}
                </div>
                <div className={classNames('prop', 'people')}>
                    <figure className={classNames('person')}>
                        <div className={classNames('prop', 'slug', 'name')}>Loraine Wilder</div>
                        <div className={classNames('prop', 'slug', 'email')}>
                            lwilder@contoso.net
                        </div>
                        <div className={classNames('prop', 'avatar')} />
                        <div className={classNames('prop', 'screen')} />
                    </figure>

                    <figure className={classNames('person')}>
                        <div className={classNames('prop', 'slug', 'name')}>
                            Kristopher Linville
                        </div>
                        <div className={classNames('prop', 'slug', 'email')}>
                            klinville@contoso.net
                        </div>
                        <div className={classNames('prop', 'avatar')} />
                    </figure>

                    <figure className={classNames('person')}>
                        <div className={classNames('prop', 'slug', 'name')}>Jewell Owen</div>
                        <div className={classNames('prop', 'slug', 'email')}>jowen@contoso.net</div>
                        <div className={classNames('prop', 'avatar')} />
                    </figure>
                </div>
            </div>

            <div className={classNames('prop', 'chosen-friend')}>
                <div className={classNames('prop', 'i-beam')} />
                <div className={classNames('prop', 'bff-persona')}>
                    <span>Loraine Wilder</span>
                </div>
            </div>

            <div className={classNames('prop', 'agreed-upon-time')}>
                <div className={classNames('prop', 'detail', 'time')}>12:00 &ndash; 13:00</div>
                <div className={classNames('prop', 'detail', 'desc')}>{loc(everyoneAvailable)}</div>
            </div>
        </div>
    );
});
